/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to create a new subscription
 * @export
 * @interface CreateSubscriptionRequest
 */
export interface CreateSubscriptionRequest {
    /**
     * 
     * @type {number}
     * @memberof CreateSubscriptionRequest
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionRequest
     */
    tierCode: CreateSubscriptionRequestTierCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionRequest
     */
    stripePaymentMethodId?: string;
    /**
     * Billing period for the subscription
     * @type {string}
     * @memberof CreateSubscriptionRequest
     */
    billingPeriod?: CreateSubscriptionRequestBillingPeriodEnum;
}


/**
 * @export
 */
export const CreateSubscriptionRequestTierCodeEnum = {
    Free: 'free',
    Starter: 'starter',
    Pro: 'pro',
    Expert: 'expert'
} as const;
export type CreateSubscriptionRequestTierCodeEnum = typeof CreateSubscriptionRequestTierCodeEnum[keyof typeof CreateSubscriptionRequestTierCodeEnum];

/**
 * @export
 */
export const CreateSubscriptionRequestBillingPeriodEnum = {
    Monthly: 'monthly',
    Yearly: 'yearly'
} as const;
export type CreateSubscriptionRequestBillingPeriodEnum = typeof CreateSubscriptionRequestBillingPeriodEnum[keyof typeof CreateSubscriptionRequestBillingPeriodEnum];


/**
 * Check if a given object implements the CreateSubscriptionRequest interface.
 */
export function instanceOfCreateSubscriptionRequest(value: object): value is CreateSubscriptionRequest {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('tierCode' in value) || value['tierCode'] === undefined) return false;
    return true;
}

export function CreateSubscriptionRequestFromJSON(json: any): CreateSubscriptionRequest {
    return CreateSubscriptionRequestFromJSONTyped(json, false);
}

export function CreateSubscriptionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSubscriptionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['companyId'],
        'tierCode': json['tierCode'],
        'stripePaymentMethodId': json['stripePaymentMethodId'] == null ? undefined : json['stripePaymentMethodId'],
        'billingPeriod': json['billingPeriod'] == null ? undefined : json['billingPeriod'],
    };
}

export function CreateSubscriptionRequestToJSON(json: any): CreateSubscriptionRequest {
    return CreateSubscriptionRequestToJSONTyped(json, false);
}

export function CreateSubscriptionRequestToJSONTyped(value?: CreateSubscriptionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'tierCode': value['tierCode'],
        'stripePaymentMethodId': value['stripePaymentMethodId'],
        'billingPeriod': value['billingPeriod'],
    };
}

